import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';
import { ColorTypes } from '../../themes/_declarations/colors';

export const ElevatedWrapper = styled.div<{
  $background?: ColorTypes;
  $type: string;
  $widgetType?: string;
}>`
  &&& {
    ${({ $type, $widgetType }) =>
      $widgetType === 'modal' &&
      css`
        box-shadow: ${({ theme }) => theme.elevations[$type]};
        padding: ${pxToRem(24)};
      `}
    background-color: ${({ $background, theme }) =>
      $background && theme.colors[$background]};
  }
`;

export const SelectedCardContainer = styled.div`
  &&& {
    position: absolute;
    background: ${({ theme: { colors } }) => colors.success};
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    right: ${pxToRem(-15)};
    top: ${pxToRem(-13)};
    border-radius: ${pxToRem(60)};
  }
`;

export const WrapperProduct = styled(ElevatedWrapper)<{
  $selected: boolean;
  $widgetType?: string;
}>`
  &&& {
    border-radius: ${pxToRem(4)};
    ${({ $selected, $widgetType }) =>
      $widgetType === 'modal' &&
      css`
        border: ${$selected ? '2px solid black' : ''};
      `};
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(16)};
    cursor: pointer;
    position: relative;
    max-width: ${pxToRem(896)};
  }
`;

export const HeaderProduct = styled.div`
  &&& {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${({ theme: { mediaQueries } }) =>
      mediaQueries.isMobile &&
      css`
        h4:first-child {
          flex-basis: 40%;
        }
      `}
    @media (max-width: 400px) {
      display: block !important;
    }
  }
`;

export const Divider = styled.div`
  &&& {
    height: ${pxToRem(1)};
    background: ${({ theme: { colors } }) => colors.neutral300};
  }
`;

export const ControlsWrapper = styled.div<{ $widgetType?: string }>`
  &&& {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    ${({ $widgetType }) =>
      $widgetType === 'modal' &&
      css`
        padding: ${pxToRem(24)};
        border-radius: ${pxToRem(4)};
        border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.brand1};
      `}

    gap: ${pxToRem(48)};

    ${({ theme: { mediaQueries } }) =>
      (mediaQueries.isDesktopSmall ||
        mediaQueries.isTablet ||
        mediaQueries.isMobile) &&
      css`
        grid-template-columns: repeat(1, 1fr);
        gap: ${pxToRem(8)};
      `}
    ${({ $widgetType }) =>
      $widgetType === 'embedded' &&
      css`
        gap: ${pxToRem(40)};
      `}
  }
`;

export const SpinnerContainer = styled.div`
  &&& {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
`;

export const ErrorWrapper = styled.div<{ $widgetType?: string }>`
  &&& {
    ${({ $widgetType }) =>
      $widgetType === 'embedded'
        ? css`
            height: ${pxToRem(40)};
          `
        : css`
            padding: ${pxToRem(16)} 0;
          `}
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const WrapperControlsTax = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(40)};
  }
`;
